import {Linking} from 'react-native';
import Config from 'react-native-config';

import {EVENT_NAMES} from '/enum/tealium.enum';
import {getTealiumUtilDefaultInstance} from '/util/tealium';

export const generateShareCartInfoPress = ({onShowInfoPopover}: any) => {
  return (payload: any) => {
    const popoverPayload = {
      heading: 'Share Cart',
      body: 'Select a Cart to share with your Clients',
      ...payload, //includes triggerRef from MetricSection
    };
    onShowInfoPopover?.(popoverPayload);
  };
};

export const generateViewSharedCartsPress = (onEventData: any) => {
  return () => {
    const sendEvent = getTealiumUtilDefaultInstance().generateTrackEvent({
      eventName: EVENT_NAMES.CTA_Click,
    });
    const baseUrl =
      Config.ENV === 'production'
        ? 'https://optavia.com'
        : 'https://www.ccv2medifast.com';
    const payload = {
      ...onEventData,
      targetLocation: baseUrl,
    };
    sendEvent(payload);

    const url = `${baseUrl}/us/en/my-account/sharecarts`;
    Linking.openURL(url);
  };
};
